import { LookupsType } from '../types/api/analytics-lookups-api';
import { BaseRouteProps } from '../types/route-props';
import { SPRYKER_ANALYTICS_LOOKUPS, ATG_ANALYTICS_LOOKUPS } from '../constants';
import { buildURL, isV3 } from '../common';
import { Method, callAxios, AxiosRequestConfig } from '../axios';
import { getBrandName } from '../locale';

export const getAnalyticsLookupsEndpointUrl = ({
  host,
  countryCode,
  languageCode,
}: BaseRouteProps): string => {
  if (isV3()) return `${host}${SPRYKER_ANALYTICS_LOOKUPS}`;

  return buildURL({
    host,
    countryCode,
    languageCode,
    endpoint: ATG_ANALYTICS_LOOKUPS,
  });
};
export const analyticsApiFetchers = {
  getAnalyticsLookupFetcher: async ({ host, countryCode, languageCode }: BaseRouteProps) => {
    const GET_PRODUCTS_INFO_URL = getAnalyticsLookupsEndpointUrl({
      host,
      countryCode,
      languageCode,
    });

    const requestSettings: AxiosRequestConfig<unknown> = {
      method: Method.GET,
      url: GET_PRODUCTS_INFO_URL,
    };
    if (isV3()) {
      requestSettings.params = {
        brand: getBrandName(),
        'country-code': countryCode,
        'language-code': languageCode,
      };
    }
    const response = await callAxios<{
      response: LookupsType;
    }>(requestSettings);

    return response.data;
  },
};
